export default __webpack_public_path__ + "static/media/hamburger-menu.b55791fc.svg";